import { NgModule } from '@angular/core';

import { FeatherModule } from 'angular-feather';
import {
	Activity, AlertCircle, Archive, ArrowLeft, BarChart2, Bell, Bookmark, BookOpen, Briefcase, Check, ChevronUp, ChevronDown, ChevronLeft, ChevronsLeft, ChevronRight, Columns, Crosshair,
	Database, Edit, Eye, EyeOff, FileText, Grid, Home, Info,
	Layout, LogOut, Lock, Menu, MessageSquare, Minimize, Minus, Moon, Package, Pause, Play, Plus, Printer,
	RotateCw ,Save, Search, Settings, Slash, Star, Sun, Unlock, Upload, User, Users, UserPlus, Volume,
	X, XCircle, XSquare, List, Circle, CheckCircle, HelpCircle, Square, Trash, Trash2, Trello,
	Clipboard, ExternalLink,
} from 'angular-feather/icons';

// Select some icons (use an object, not an array)
const icons = {
	Activity,
	AlertCircle,
	Archive,
	ArrowLeft,
	BarChart2,
	Bell,
	Bookmark,
	BookOpen,
	Briefcase,
	CheckCircle,
	Circle,
	Clipboard,
	Check,
	ChevronUp,
	ChevronDown,
	ChevronLeft,
	ChevronsLeft,
	ChevronRight,
	Columns,
	Crosshair,
	Database,
	Edit,
	ExternalLink,
	Eye,
	EyeOff,
	FileText,
	Grid,
	HelpCircle,
	Home,
	Info,
	Layout,
	List,
	Lock,
	LogOut,
	Menu,
	MessageSquare,
	Minimize,
	Minus,
	Moon,
	Package,
	Pause,
	Play,
	Plus,
	Printer,
	RotateCw,
	Save,
	Search,
	Settings,
	Slash,
	Star,
	Sun,
	Square,
	Trash,
	Trash2,
	Trello,
	Unlock,
	Upload,
	User,
	Users,
	UserPlus,
	Volume,
	X,
	XCircle,
	XSquare,
};

@NgModule({
	imports: [
		FeatherModule.pick(icons)
	],
	exports: [
		FeatherModule
	]
})
export class IconsModule { }
